const getIsLaborTicketEnabled = (state) => {
  return state?.companySettings?.laborTicketEnabled ?? false;
};

export { getIsLaborTicketEnabled };
